import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded transition-colors",
  {
    variants: {
      variant: {
        default:
          "bg-blue-4 text-blue-11 selection:bg-blue-5 data-[active=true]:bg-blue-5 data-[active=true]:ring-1 data-[active=true]:ring-blue-7",
        secondary:
          "bg-slate-3 text-slate-11 selection:bg-slate-4 data-[active=true]:bg-slate-4 data-[active=true]:ring-1 data-[active=true]:ring-slate-7",
        outline:
          "border border-slate-6 text-slate-11 selection:bg-slate-7 data-[active=true]:bg-slate-7 data-[active=true]:border data-[active=true]:ring-slate-7",
        destructive:
          "bg-red-3 text-red-11 selection:bg-red-4 data-[active=true]:bg-red-4 data-[active=true]:ring-1 data-[active=true]:ring-red-7",
        red: "bg-red-3 text-red-11 selection:bg-red-4 data-[active=true]:bg-red-4 data-[active=true]:ring-1 data-[active=true]:ring-red-7",
        green:
          "bg-green-3 text-green-11 selection:bg-green-4 data-[active=true]:bg-green-4 data-[active=true]:ring-1 data-[active=true]:ring-green-7",
        slate:
          "bg-slate-3 text-slate-12 selection:bg-slate-4 data-[active=true]:bg-slate-4 data-[active=true]:ring-1 data-[active=true]:ring-slate-7",
        amber:
          "bg-amber-3 text-amber-11 selection:bg-amber-4 data-[active=true]:bg-amber-4 data-[active=true]:ring-1 data-[active=true]:ring-amber-7",
        orange:
          "bg-orange-3 text-orange-11 selection:bg-orange-4 data-[active=true]:bg-orange-4 data-[active=true]:ring-1 data-[active=true]:ring-orange-7",
        blue: "bg-blue-3 text-blue-11 selection:bg-blue-4 data-[active=true]:bg-blue-4 data-[active=true]:ring-1 data-[active=true]:ring-blue-7",
        plum: "bg-plum-3 text-plum-11 selection:bg-plum-4 data-[active=true]:bg-plum-4 data-[active=true]:ring-1 data-[active=true]:ring-plum-7",
        mint: "bg-mint-3 text-mint-11 selection:bg-mint-4 data-[active=true]:bg-mint-4 data-[active=true]:ring-1 data-[active=true]:ring-mint-7",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  active?: boolean
}

function Badge({ className, active, variant, size, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      data-active={active}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
